import { Box, Button, Grid, Typography, TextField, Modal, Breadcrumbs, Tooltip, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { HttpRequest } from "../HttpRequest";
import { ArrowBackIos, Circle, EditOutlined } from "@mui/icons-material";
import CustomInputLabel from "../common/CustomInputLabel";
import { SuccessAlert } from "../common/snackbar/success";
import { ErrorAlert } from "../common/snackbar/error";
import CustomSearchInput from "../common/CustomSearchInput";
import warningIcon from '../../images/warning-remove-icn.svg';
import DeleteIcon from '@mui/icons-material/Delete';
import { DataGrid } from "@mui/x-data-grid";
import secureLocalStorage from "react-secure-storage";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ReusableModal from "../common/ReusableModal";

const deleteTagModal = {
  borderRadius: "10px", backgroundColor: "#fff", position: 'absolute', top: '40%', left: '50%', transform: 'translate(-50%, -50%)', width: "400px", height: "130px", p: '61px 22px 165px 63px', border: '1px #707070', m: '55px 104px 6.5px 118px'
}
const TagsComponent = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const [search, setSearch] = useState("");
  const [successShow, setSuccessShow] = useState({ state: false, message: "" })
  const [errorShow, setErrorShow] = useState({ state: false, message: "" })
  const [showAddTagModal, setShowAddTagModal] = useState(false)
  const [showEditTagModal, setShowEditTagModal] = useState(false)
  const [tagDataData, setTagDataData] = useState({
    tagName: "",
    tagDescription: "",
  })
  const [tag, setTag] = useState({});
  const [openDeleteTag, setOpenDeleteTag] = useState(false)
  const handleOpenDeleteTag = () => { setOpenDeleteTag(true) }
  const handleCloseDeleteTag = () => { setOpenDeleteTag(false) }
  const [dataGridPageSize, setPageSize] = useState(10);
  const [pageState, setPageState] = useState({ isLoading: false, data: [], total: 0, page: 1, pageSize: dataGridPageSize, })

  const handleFormData = (e) => {
    const { name, value } = e.target
    setTagDataData({ ...tagDataData, [name]: value })
  }
  const handleRowClick = (event, params) => {
    event.stopPropagation();
    setTagDataData({
      tagName: params?.row?.tagName,
      tagDescription: params?.row?.tagDescription,
    })
    setTag(params?.row);
    setShowEditTagModal(true);
  }
  const columns = [
    {
      field: 'tagName', headerName: 'Tag Name', flex: isMobile ? 1 : 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Tag Name </Box>) },
      renderCell: (params) => {
        return (<Box onClick={(event)=>handleRowClick(event,params)}  style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "500" }}>
          <Grid container spacing={2}>
            <Grid item>
              {params?.row?.tagName}
            </Grid>
          </Grid>
        </Box>)
      }
    },
    {
      field: 'tagDescription', headerName: 'Tag Description', flex: isMobile ? 1.5 : 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Tag Description   </Box>) },
      renderCell: (params) => {
        return (<Box onClick={(event)=>handleRowClick(event,params)}  style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "500" }}>
          {params?.row?.tagDescription}
        </Box>)
      }
    },
    {
      field: 'action', headerName: 'Action', flex: isMobile ? 0.8 : 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Action  </Box>) },
      renderCell: (params) => {
        const onClickDelete = (event) => {
          event.stopPropagation();
          setTag(params?.row);
          handleOpenDeleteTag(true);
        }
        return (
          <Box  style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "13px" : "25px", fontWeight: "500", marginTop: isMobile ? '5px' : '0' }}>
            <Tooltip title= "Edit">
            <EditOutlined onClick={(event)=>handleRowClick(event,params)}  sx={{ color: '#032541', marginRight: '10px', fontSize: isMobile ? '18px' : 'inherit' }} />
            </Tooltip>
            <Tooltip title="Delete">
            <DeleteIcon onClick={onClickDelete} sx={{ color: '#DC3545', fontSize: isMobile ? '18px' : 'inherit' }} />
            </Tooltip>
          </Box>
        )
      }
    },
  ]
  const getTagData = () => {
    const businessNumber = secureLocalStorage.getItem("businessId");
    HttpRequest({
      method: 'GET',
      url: `/api/v1/ecommerce/business/getTag?businessNumber=${businessNumber}&searchValue=${search}`
    }).then((data) => {
      setPageState((old) => ({
        ...old,
        isLoading: false,
        total: data?.response.count,
        data: data.response?.data,
      }));
    }).catch((error) => {
    });
  }

  useEffect(() => {
    getTagData()
  }, [search])


  const handleTagAddSubmit = () => {
    if (!tagDataData.tagName) {
      setErrorShow({ state: true, message: "Tag name is required" });
      return;
    }
    if (!tagDataData.tagDescription) {
      setErrorShow({ state: true, message: "Tag description is required" });
      return;
    }
    HttpRequest({
      method: 'POST',
      url: `/api/v1/ecommerce/business/addTag`,
      body: tagDataData

    }).then((data) => {
      if (data?.status === 200) {
        setSuccessShow({ state: true, message: "Tag Name updated successfully" });
        setShowAddTagModal(false)
        getTagData()
        setTagDataData({
          tagName: "",
          tagDescription: "",

        })
      } else {
        setErrorShow({ state: true, message: data.response?.data?.message });
      }
    }).catch((error) => {
      setErrorShow({ state: true, message: "Error adding shipping Region" });
    })
  }
  const handleTagUpdateSubmit = () => {
    if (!tagDataData.tagName) {
      setErrorShow({ state: true, message: "Location name is required" });
      return;
    }
    if (!tagDataData.tagDescription) {
      setErrorShow({ state: true, message: "Location description is required" });
      return;
    }
    HttpRequest({
      method: 'POST',
      url: `/api/v1/ecommerce/business/editBusinessTag/${tag._id}`,
      body: tagDataData
    }).then((data) => {
      if (data?.status === 200) {
        setSuccessShow({ state: true, message: "Tag Name updated successfully" });
        setShowEditTagModal(false)
        getTagData()
        setTagDataData({
          tagName: "",
          tagDescription: "",
        })
      } else {
        setErrorShow({ state: true, message: data.response?.data?.message });
      }
    }).catch((error) => {
      setErrorShow({ state: true, message: "Error adding shipping Region" });
    })
  }
  const handleDeleteTag = (id) => {
    handleCloseDeleteTag();
    HttpRequest({
      method: 'DELETE',
      url: `/api/v1/ecommerce/business/deleteBusinessTag/${id}`,
    }).then((data) => {
      if (data?.status === 200) {
        setSuccessShow({ state: true, message: "Tag deleted successfully" });
        setTag({});
        getTagData()
        setTagDataData({
          tagName: "",
          tagDescription: "",
        })
      } else {
        setErrorShow({ state: true, message: data.response?.data?.message });
      }
    }).catch((error) => {
      setErrorShow({ state: true, message: "Error deleting tag" });
    })
  }

  const breadcrumbs = [
      <Typography key="X" sx={{ color: "#707070", fontSize: "0.875rem", ml: isMobile ? 0 : 3 }}>
          Dashboard
      </Typography>,
      <Typography key={"add"} sx={{ color: "#dc3545", fontSize: "0.875rem" }}>
          Tags
      </Typography>
    ];
  return (
    <Box sx={{ mt: { xs: "15%", sm: "4%" }, pr: { xs: 2, sm: "3.5%" }, width: { xs: "100vw", sm: "calc(100vw - 355px)" }, maxWidth: "100%", overflowX: "hidden", boxSizing: "border-box", px: { xs: 2, sm: 0 }, ml: { xs: -3, sm: 0 } }}>      
      <SuccessAlert vertical="top" horizontal="right" onClose={() => setSuccessShow({ ...successShow, state: false })} open={successShow.state} message={successShow.message} />
      <ErrorAlert vertical="top" horizontal="right" onClose={() => setErrorShow({ ...errorShow, state: false })} open={errorShow.state} message={errorShow.message} />
      
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: { xs: "flex-start", sm: "center" }, flexDirection: { xs: "column", sm: "row" }, gap: { xs: 2, sm: 0 } }}>
        <Box sx={{ flexDirection: "column", flex: 1 }}>
          <Box mb={1.5}>
            {showAddTagModal ? (
              <Box variant="h4" sx={{ display: 'flex', alignItems: 'center' }}>
                <ArrowBackIos sx={{ width: '25px', height: '35px', objectFit: 'contain'}} onClick={() => { setShowAddTagModal(false) }} />
                <Typography sx={{ color: "#032541", fontSize: { xs: "18px", sm: "28px" }, fontStyle: "normal", fontWeight: "600" }}>
                  Add Tag
                </Typography>
              </Box>
            ) : showEditTagModal ? (
              <Box variant="h4" sx={{ display: 'flex', alignItems: 'center' }}>
                <ArrowBackIos sx={{ width: '25px', height: '35px', objectFit: 'contain', mt: 0.5 }} onClick={() => { setShowEditTagModal(false) }} />
                <Typography sx={{ color: "#032541", fontSize: { xs: "18px", sm: "28px" }, fontStyle: "normal", fontWeight: "600" }}>
                  Edit Tag
                </Typography>
              </Box>
            ) : (
              <Typography variant="h4" sx={{ color: "#032541", fontSize: { xs: "18px", sm: "28px" }, fontStyle: "normal", fontWeight: "600" }}>
                Tags
              </Typography>
            )}
          </Box>
          <Box>
            <Grid item sx={{ mt: 1, mb: { xs: 1, sm: 1 }, ml: { sm: -3 } }}>
              <Breadcrumbs style={{ fontFamily: 'Poppins', fontSize: { xs: "11px", sm: "13px" } }} separator={<FiberManualRecordIcon style={{ fontSize: "0.625rem", fontFamily: 'Poppins', color: "#e1e5e8" }} />} aria-label="breadcrumb">
                {breadcrumbs}
              </Breadcrumbs>
            </Grid>
            <Typography variant="h4" sx={{ color: "#707070", fontSize: { xs: "12px", sm: "14px" }, fontStyle: "normal", fontWeight: "normal", }}>
              {showAddTagModal ? 'Create different tags' : showEditTagModal ? 'Edit tag details' : 'View and manage your Tags'}
            </Typography>
          </Box>
        </Box>
        {showAddTagModal || showEditTagModal ? null :
          <Box sx={{ width: { xs: '100%', sm: 'auto' }, mt: { xs: 2, sm: 0 } }}>
            <Button variant="contained" sx={{ backgroundColor: "#032541", color: "#fff", textTransform: "none", borderRadius: "5px", padding: "10.4px 18px 9.6px 19px", height: "40px", fontWeight: "600", "&:hover": { backgroundColor: "#032541", color: "#fff" }, width: { xs: '100%', sm: 'auto' }}} onClick={() => setShowAddTagModal(true)}>
              Add Tag
            </Button>
          </Box>
        }
      </Box>
      
      {showAddTagModal || showEditTagModal ? null :
        <Box sx={{ display: 'flex', mt: 2 }}>
          <Box sx={{ width: { xs: '100%', sm: 'auto' } }}>
            <CustomSearchInput placeholder={"Search tag name ...."} name="search" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: { xs: '100%', sm: 'auto' } }} />
          </Box>
        </Box>
      }
      
      {showAddTagModal ?
        <>
          <Box sx={{ width: { xs: "100%", sm: "500px" }, mt: 2 }}>
            <Box sx={{ width: "100%", marginTop: "20px" }}>
              <CustomInputLabel label="Tag  Name" placeholder="Enter Tag Name " />
              <TextField label="Tag Name" value={tagDataData?.tagName} name="tagName" onChange={handleFormData} sx={{ width: "100%" }} size={isMobile ? "small" : "medium"}/>
            </Box>
            <Box sx={{ width: "100%", marginTop: "20px" }}>
              <CustomInputLabel label="Tag Description" placeholder="Enter Tag  Description*" />
              <TextField name={"tagDescription"} value={tagDataData.tagDescription} onChange={handleFormData} placeholder={"Description"} variant="outlined" margin="dense" sx={{ marginBottom: 2, width: "100%" }} multiline minRows={2} size={isMobile ? "small" : "medium"}/>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end", alignContent: "end", gap: 1, flexDirection: { xs: "column", sm: "row" } }}>
              <Button variant="contained" sx={{ backgroundColor: "#fff", color: "#dc3545", textTransform: "none", borderRadius: "5px", border: "1px solid #dc3545", padding: "10.4px 30px 9.6px 30px", height: "40px", fontWeight: "600", "&:hover": { backgroundColor: "#fff", color: "#dc3545" }, width: { xs: '100%', sm: 'auto' }}} onClick={() => setShowAddTagModal(false)}>
                Cancel
              </Button>
              <Button variant="contained" sx={{ backgroundColor: "#032541", color: "#fff", textTransform: "none", borderRadius: "5px", padding: "10.4px 18px 9.6px 19px", height: "40px", fontWeight: "600", "&:hover": { backgroundColor: "#032541", color: "#fff" }, width: { xs: '100%', sm: 'auto' }}} onClick={handleTagAddSubmit}>
                Add Tag
              </Button>
            </Box>
          </Box>
        </> : showEditTagModal ?
          <>
            <Box sx={{ width: { xs: "100%", sm: "500px" }, mt: 2 }}>
              <Box sx={{ width: "100%", marginTop: "20px" }}>
                <CustomInputLabel label="Tag  Name" placeholder="Enter Tag Name " />
                <TextField label="Tag Name" value={tagDataData?.tagName} name="tagName" onChange={handleFormData} sx={{ width: "100%" }} size={isMobile ? "small" : "medium"}/>
              </Box>
              <Box sx={{ width: "100%", marginTop: "20px" }}>
                <CustomInputLabel label="Tag Description" placeholder="Enter Tag  Description*" />
                <TextField name={"tagDescription"} value={tagDataData.tagDescription} onChange={handleFormData} placeholder={"Description"} variant="outlined" margin="dense" sx={{ marginBottom: 2, width: "100%" }} multiline minRows={2} size={isMobile ? "small" : "medium"}/>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "flex-end", alignContent: "end", gap: 1, flexDirection: { xs: "column", sm: "row" } }}>
                <Button variant="contained" sx={{ backgroundColor: "#fff", color: "#dc3545", textTransform: "none", borderRadius: "5px", border: "1px solid #dc3545", padding: "10.4px 30px 9.6px 30px", height: "40px", fontWeight: "600", "&:hover": { backgroundColor: "#fff", color: "#dc3545" }, width: { xs: '100%', sm: 'auto' }}} onClick={() => setShowEditTagModal(false)}>
                  Cancel
                </Button>
                <Button variant="contained" sx={{ backgroundColor: "#032541", color: "#fff", textTransform: "none", borderRadius: "5px", padding: "10.4px 18px 9.6px 19px", height: "40px", fontWeight: "600", "&:hover": { backgroundColor: "#032541", color: "#fff" }, width: { xs: '100%', sm: 'auto' }}} onClick={handleTagUpdateSubmit}>
                  Update
                </Button>
              </Box>
            </Box>
          </>
          : <Box sx={{ width: '100%', overflowX: 'auto', mt: 2 }}>
            <Box sx={{ minWidth: { xs: 800, sm: '100%' } }}>
            <DataGrid
              sx={{ minHeight: '500px', height: 'auto', width: 'auto', fontFamily: 'Poppins', fontSize: isMobile ? '10px' : '12px', color: '#272d3d', boxShadow: 0, border: 0, '& .MuiDataGrid-cell': { fontSize: isMobile ? '10px' : '12px',}}}
              rowCount={pageState.total}
              pagination
              loading={pageState.isLoading}
              page={pageState.page - 1}
              pageSizeOptions={[1, 10, 20, 50, 100]}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: dataGridPageSize,
                    page: pageState.page - 1,
                  },
                },
              }}
              pageSize={dataGridPageSize}
              onPaginationModelChange={(data) => {
                const { pageSize, page } = data;
                setPageState((old) => ({ ...old, page: page + 1, pageSize: pageSize }));
                setPageSize(pageSize)
              }}
              paginationMode="server"
              columns={columns}
              rows={pageState.data}
              getRowId={(row) => row._id}
            />
            </Box>
          </Box>
      }

      <ReusableModal open={openDeleteTag} onClose={handleCloseDeleteTag}>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", pt: 4, px: 3,}}>
          <Box sx={{ mb: 2 }}>
            <img src={warningIcon} alt="warning" width={70} height={70} style={{ objectFit: "contain" }}/>
          </Box>
          <Typography sx={{ color: "#032541", fontFamily: "Poppins", fontWeight: 600, fontSize: { xs: "16px", sm: "18px" }, mb: 1.5, textAlign: "center", }}>
            Delete Tag?
          </Typography>
          <Typography sx={{ color: "#707070", fontFamily: "Poppins", fontSize: { xs: "12px", sm: "14px" }, mb: 2, textAlign: "center", }}>
            Selected tag will be deleted. This action cannot be undone.
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center",justifyContent: "center",mb: 3, }}>
            <Circle sx={{ width: "10px", height: "10px", color: "#0c253f", mr: 1 }} />
            <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "14px", sm: "16px" }, color: "#032541", textAlign: "center",}}>
              {tag?.tagName}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <Button sx={{ height: "45px", width: "125px", borderRadius: "4px", backgroundColor: "#dc3545", color: "#fff", fontWeight: 600, fontSize: "14px", fontFamily: "Poppins", textTransform: "none", "&:hover": { backgroundColor: "#c82333" }}} onClick={() => handleDeleteTag(tag._id)}>
              Delete
            </Button>
          </Box>
        </Box>
      </ReusableModal>
    </Box>
  )
}

export default TagsComponent